import { frontendURL } from '../../../helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

import account from './account/account.routes';
import agent from './agents/agent.routes';
import assignmentPolicy from './assignmentPolicy/assignmentPolicy.routes';
import agentBot from './agentBots/agentBot.routes';
import attributes from './attributes/attributes.routes';
import automation from './automation/automation.routes';
import auditlogs from './auditlogs/audit.routes';
import billing from './billing/billing.routes';
import canned from './canned/canned.routes';
import emailTemplates from './emailTemplates/emailTemplates.routes';
import forms from './forms/forms.routes';
import growthLinks from './growth-links/growth-links.routes';
import voices from './voices/voices.routes';
import inbox from './inbox/inbox.routes';
import integrations from './integrations/integrations.routes';
import aiIgnoredNumbers from './aiIgnoredNumbers/aiIgnoredNumbers.routes';
import labels from './labels/labels.routes';
import lossReasons from './lossReasons/lossReasons.routes';
import products from './products/products.routes';
import macros from './macros/macros.routes';
import salesGoals from './salesGoals/salesGoals.routes';
import reports from './reports/reports.routes';
import store from '../../../store';
import sla from './sla/sla.routes';
import teams from './teams/teams.routes';
import customRoles from './customRoles/customRole.routes';
import profile from './profile/profile.routes';
import security from './security/security.routes';
import callDevices from './callDevices/callDevices.routes';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings'),
      name: 'settings_home',
      meta: {
        permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
      },
      redirect: to => {
        if (
          store.getters.getCurrentRole === 'administrator' &&
          store.getters.getCurrentCustomRoleId === null
        ) {
          return { name: 'general_settings_index', params: to.params };
        }

        return { name: 'canned_list', params: to.params };
      },
    },
    ...account.routes,
    ...agent.routes,
    ...assignmentPolicy.routes,
    ...agentBot.routes,
    ...attributes.routes,
    ...automation.routes,
    ...auditlogs.routes,
    ...billing.routes,
    ...canned.routes,
    ...emailTemplates.routes,
    ...forms.routes,
    ...growthLinks.routes,
    ...inbox.routes,
    ...integrations.routes,
    ...aiIgnoredNumbers.routes,
    ...labels.routes,
    ...lossReasons.routes,
    ...products.routes,
    ...macros.routes,
    ...salesGoals.routes,
    ...reports.routes,
    ...sla.routes,
    ...teams.routes,
    ...customRoles.routes,
    ...profile.routes,
    ...security.routes,
    ...callDevices.routes,
    ...voices.routes,
  ],
};
